/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PostProcessingStatusHistory } from "./PostProcessingStatusHistory";
import {
  PostProcessingStatusHistoryFromJSON,
  PostProcessingStatusHistoryFromJSONTyped,
  PostProcessingStatusHistoryToJSON,
  PostProcessingStatusHistoryToJSONTyped,
} from "./PostProcessingStatusHistory";

/**
 *
 * @export
 * @interface PaginatedPostProcessingStatusHistoryList
 */
export interface PaginatedPostProcessingStatusHistoryList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<PostProcessingStatusHistory>;
}

/**
 * Check if a given object implements the PaginatedPostProcessingStatusHistoryList interface.
 */
export function instanceOfPaginatedPostProcessingStatusHistoryList(
  value: object
): value is PaginatedPostProcessingStatusHistoryList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedPostProcessingStatusHistoryListFromJSON(
  json: any
): PaginatedPostProcessingStatusHistoryList {
  return PaginatedPostProcessingStatusHistoryListFromJSONTyped(json, false);
}

export function PaginatedPostProcessingStatusHistoryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedPostProcessingStatusHistoryList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(PostProcessingStatusHistoryFromJSON),
  };
}

export function PaginatedPostProcessingStatusHistoryListToJSON(
  json: any
): PaginatedPostProcessingStatusHistoryList {
  return PaginatedPostProcessingStatusHistoryListToJSONTyped(json, false);
}

export function PaginatedPostProcessingStatusHistoryListToJSONTyped(
  value?: PaginatedPostProcessingStatusHistoryList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(PostProcessingStatusHistoryToJSON),
  };
}
